import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { Article } from './article';
import { Conditionnement } from './conditionnement';
import { DomiciliationBancaire } from './domiciliations-bancaires';
import { ModeCamion } from './mode-camion';
import { ModeReglement } from './mode-reglement';

@JsonObject
export class ParamsCommande {
  constructor (
    id?: number,
    article?: Article,
    conditionnements?: Conditionnement[],
    modeCamions?: ModeCamion[],
    modesReglement?: ModeReglement[],
    domiciliationsBancaires?: DomiciliationBancaire[]
  ) {
    this.id = id;
    this.article = article;
    this.conditionnements = conditionnements;
    this.modeCamions = modeCamions;
    this.modesReglement = modesReglement;
    this.domiciliationsBancaires = domiciliationsBancaires;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(Article)
  article: Article;

  @JsonProperty([Conditionnement])
  conditionnements: Conditionnement[];

  @JsonProperty([ModeCamion])
  @Optional
  modeCamions: ModeCamion[];

  @JsonProperty([ModeReglement])
  modesReglement: ModeReglement[]

  @JsonProperty([DomiciliationBancaire])
  domiciliationsBancaires: DomiciliationBancaire[]
}
